import { useContext } from 'react'

import { AuthContext } from '@/contexts/FirebaseAuthContext'
import useT from '@/i18n/useT'

const useAuth = () => {
  const context = useContext(AuthContext)
  const { t } = useT()

  if (!context) throw new Error(t('useAuth.error.authContextMissing'))

  return context
}

export default useAuth
